import React, { useState, useEffect } from 'react';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import { CircularProgress } from '@material-ui/core';
import '../styling/sidebar.css';
import '../styling/incomepop.css';
import GetUser from '../services/get-user';


export default function IRPopup(props) {
  const [name, setName] = useState(props.keydata.name);
  const [revenue, setRevenue] = useState(props.keydata.revenue);
  const [stream, setStream] = useState(props.stream + 1);
  const [source, setSource] = useState(props.keydata.source);
  const [note, setNote] = useState(props.keydata.note);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const user= GetUser();

  function validateForm() {
    return name.length > 0 && source.length > 0;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    try{
      //'http://localhost:8080/income/add_income'
      // return axios.post('http://localhost:8080/income/remove_income', {
      return axios.post('https://sotira-back-test.herokuapp.com/income/remove_income', {
        userID: user.userID,
        income:stream,
      }).then(response=>{
        setLoading(false)
        props.closeRemoveIncome(false)
        props.setReloadTableData((prevState)=>!prevState)
      });
    } catch(e: any){
      alert(e.message);
      setLoading(false)
    }
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="name">
        <Form.Label> Name </Form.Label>
        <Form.Control
          autoFocus
          type="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          readOnly
        />
      </Form.Group>

      <Form.Group controlId="source">
        <Form.Label> Source </Form.Label>
        <Form.Control
          autoFocus
          type="source"
          value={source}
          onChange={(e) => setSource(e.target.value)}
          readOnly
        />
      </Form.Group>

      <Form.Group controlId="note" className="">
        <Form.Label className="control-label"> Note </Form.Label>
        <Form.Control
          autoFocus
          type="note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          readOnly
        />
      </Form.Group>

      <Button block size="sm" type="submit" disabled={!validateForm()}>
      {loading ?
        <><CircularProgress className="file-loader mr-3" />Removing</>
        : 'Confirm Removal'
      } 
      </Button>
    </Form>
  );
};
